import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=fe3b6be0&scoped=true&"
import script from "./Quiz.js?vue&type=script&lang=js&"
export * from "./Quiz.js?vue&type=script&lang=js&"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=fe3b6be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3b6be0",
  null
  
)

export default component.exports